import React from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';

// Importa las imágenes correctamente
import img1 from '../assets/imagen1.jpg';
import img2 from '../assets/imagen2.jpg';
import img3 from '../assets/imagen3.jpg';
import img4 from '../assets/imagen4.jpg';

const imagenes = [
  {
    src: img1,
    alt: 'Servicio 1',
    titulo: 'Mantenimiento de Aires Acondicionados y equipos de refrigeración',
    descripcion: 'Mantenimiento de Aires acondicionados residenciales, comerciales e indutriales'
  },
  {
    src: img2,
    alt: 'Servicio 2',
    titulo: 'Montajes Mecánicos',
    descripcion: 'Montajes Mecánicos de tuberias y estructuras metálicas'
  },
  {
    src: img3,
    alt: 'Servicio 3',
    titulo: 'Metrología de Masas',
    descripcion: 'Servicios de calibración de masas y asesoría en temas de metrología Industrial'
  },
  {
    src: img4,
    alt: 'Servicio 4',
    titulo: 'Desarrollo de Software',
    descripcion: 'Desarrollo de soluciones de software con herramientas de codigo abierto personalizadas'
  },
];

const Trabajos = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section id="servicios-carrusel" style={{ backgroundColor: 'white', padding: '4rem 1rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Algunos de Nuestros Servicios</h2>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ maxWidth: '800px', margin: '0 auto' }}
      >
        <Slider {...settings}>
          {imagenes.map((img, index) => (
            <div key={index} style={{ position: 'relative', padding: '1rem', textAlign: 'center' }}>
              <img
                src={img.src}
                alt={img.alt}
                style={{
                  maxHeight: '450px',
                  width: '100%',
                  objectFit: 'cover',
                  borderRadius: '15px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  left: '20px',
                  color: 'white',
                  textAlign: 'left',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  padding: '1rem',
                  borderRadius: '10px',
                  maxWidth: '80%',
                }}
              >
                <h3 style={{ margin: 0, fontSize: '1.5rem' }}>{img.titulo}</h3>
                <p style={{ margin: 0, fontSize: '1rem' }}>{img.descripcion}</p>
              </div>
            </div>
          ))}
        </Slider>
      </motion.div>
    </section>
  );
};

export default Trabajos;

